import { render, staticRenderFns } from "./X-intervention-card.vue?vue&type=template&id=3d0dfe69&scoped=true"
import script from "./X-intervention-card.vue?vue&type=script&lang=js"
export * from "./X-intervention-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0dfe69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d0dfe69')) {
      api.createRecord('3d0dfe69', component.options)
    } else {
      api.reload('3d0dfe69', component.options)
    }
    module.hot.accept("./X-intervention-card.vue?vue&type=template&id=3d0dfe69&scoped=true", function () {
      api.rerender('3d0dfe69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/intervention/X-intervention-card.vue"
export default component.exports